import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from 'react-router-dom'
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLungs, faTable, faArrowRight, faTasks, faTachometer, faEye, faPlus, faTrashCan, faPencil, faArrowLeft, faTrash } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select'

import { EQUIPMENT_OPTIONS } from "../../Constants/FieldOptions";
import { getSessionTemplateDetailAPI } from "../../API/SessionTemplate";
import { getSelectedOptions } from "../../Helpers/selectHelper";
import { putSessionTemplateUpdateAPI } from "../../API/SessionTemplate";
import FormErrorBox from "../Reusable/FormErrorBox";
import FormInputField from "../Reusable/FormInputField";
import FormTextareaField from "../Reusable/FormTextareaField";
import FormMultiSelectField from "../Reusable/FormMultiSelectField";
import FormRadioField from "../Reusable/FormRadioField";
import PageLoadingContent from "../Reusable/PageLoadingContent";
import { getSessionTemplateListAPI, deleteSessionTemplateAPI } from "../../API/SessionTemplate";
import { useRecoilState } from 'recoil';
import { topAlertMessageState, topAlertStatusState } from "../../AppState";


function SessionTemplateDetailForBreathworkOption() {
    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);

    ////
    //// URL Parameters.
    ////

    const { sid } = useParams()

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [sessionTemplate, setSessionTemplate] = useState({});
    const [selectedBreathworkOptionForDeletion, setSelectedBreathworkOptionForDeletion] = useState("");
    const [isFetching, setFetching] = useState(false);

    ////
    //// API.
    ////

    function onSessionTemplateDetailForBreathworkOptionSuccess(response){
        console.log("onSessionTemplateDetailForBreathworkOptionSuccess: Starting...");
        setSessionTemplate(response);
    }

    function onSessionTemplateDetailForBreathworkOptionError(apiErr) {
        console.log("onSessionTemplateDetailForBreathworkOptionError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateDetailForBreathworkOptionDone() {
        console.log("onSessionTemplateDetailForBreathworkOptionDone: Starting...");
        setFetching(false);
    }

    function onBreathworkOptionDeleteSuccess(response){
        console.log("onBreathworkOptionDeleteSuccess: Starting..."); // For debugging purposes only.

        // Update notification.
        setTopAlertStatus("success");
        setTopAlertMessage("Breathwork option deleted");
        setTimeout(() => {
            console.log("onDeleteConfirmButtonClick: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Fetch again an updated list.
        // fetchList();
    }

    function onBreathworkOptionDeleteError(apiErr) {
        console.log("onBreathworkOptionDeleteError: Starting..."); // For debugging purposes only.
        setErrors(apiErr);

        // Update notification.
        setTopAlertStatus("danger");
        setTopAlertMessage("Failed deleting");
        setTimeout(() => {
            console.log("onBreathworkOptionDeleteError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onBreathworkOptionDeleteDone() {
        console.log("onBreathworkOptionDeleteDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    const onSelectBreathworkOptionForDeletion = (e, breathworkOption) => {
        console.log("onSelectBreathworkOptionForDeletion", breathworkOption);
        setSelectedBreathworkOptionForDeletion(breathworkOption);
    }

    const onDeselectBreathworkOptionForDeletion = (e) => {
        console.log("onDeselectBreathworkOptionForDeletion");
        setSelectedBreathworkOptionForDeletion("");
    }

    const onDeleteConfirmButtonClick = (e) => {
        console.log("onDeleteConfirmButtonClick", selectedBreathworkOptionForDeletion); // For debugging purposes only.

        //
        // The following code will remove the data from the JSON.
        //

        let vsIndex;
        for (let breathworkOptionIndex in sessionTemplate.breathworkOptions) {
            let vs = sessionTemplate.breathworkOptions[breathworkOptionIndex];
            if (vs.name === selectedBreathworkOptionForDeletion.name) {
                vsIndex = breathworkOptionIndex;
                break;
            }
        }
        console.log("breathworkOptionIndex:", vsIndex);
        sessionTemplate.breathworkOptions.splice(vsIndex, 1);

        // Remove from state.
        setSelectedBreathworkOptionForDeletion("");

        // Update the sessionTemplate.
        console.log("onSubmitClick, sessionTemplate:", sessionTemplate);
        putSessionTemplateUpdateAPI(sessionTemplate, onSessionTemplateUpdateSuccess, onSessionTemplateUpdateError, onSessionTemplateUpdateDone);
    }

    function onSessionTemplateUpdateSuccess(response){
        // For debugging purposes only.
        console.log("onSessionTemplateUpdateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("SessionTemplate updated");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onSessionTemplateUpdateSuccess: Delayed for 2 seconds.");
            console.log("onSessionTemplateUpdateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);
    }

    function onSessionTemplateUpdateError(apiErr) {
        console.log("onSessionTemplateUpdateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onSessionTemplateUpdateError: Delayed for 2 seconds.");
            console.log("onSessionTemplateUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateUpdateDone() {
        console.log("onSessionTemplateUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.

            setFetching(true);
            getSessionTemplateDetailAPI(
                sid,
                onSessionTemplateDetailForBreathworkOptionSuccess,
                onSessionTemplateDetailForBreathworkOptionError,
                onSessionTemplateDetailForBreathworkOptionDone
            );
        }

        return () => { mounted = false; }
    }, [sid]);

    ////
    //// Component rendering.
    ////

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/session-templates" aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Templates</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Details (Breathwork Options)</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/session-templates`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Session Templates</Link></li>
                        </ul>
                    </nav>

                    {/* Modal(s) */}
                    <nav class="">
                        <div class={`modal ${selectedBreathworkOptionForDeletion ? 'is-active' : ''}`}>
                            <div class="modal-background"></div>
                            <div class="modal-card">
                                <header class="modal-card-head">
                                    <p class="modal-card-title">Are you sure?</p>
                                    <button class="delete" aria-label="close" onClick={onDeselectBreathworkOptionForDeletion}></button>
                                </header>
                                <section class="modal-card-body">
                                    You are about to delete this <strong>breathwork option</strong> and all the data inside of it. This action is cannot be undone. Are you sure you would like to continue?
                                </section>
                                <footer class="modal-card-foot">
                                    <button class="button is-success" onClick={onDeleteConfirmButtonClick}>Confirm</button>
                                    <button class="button" onClick={onDeselectBreathworkOptionForDeletion}>Cancel</button>
                                </footer>
                            </div>
                        </div>
                    </nav>
                    <nav class="box">

                        {/* Title + Options */}
                        <div class="columns">
                            <div class="column">
                                <p class="title is-4"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Template</p>
                            </div>
                            <div class="column has-text-right">
                                <Link to={`/session-template/${sid}/breathwork-options/add`} class="button is-small is-success is-fullwidth-mobile" type="button">
                                    <FontAwesomeIcon className="mdi" icon={faPlus} />&nbsp;New Breathwork Option
                                </Link>
                            </div>
                        </div>

                        {/* Tab Navigation */}
                        <div class="tabs is-medium">
                            <ul>
                                <li>
                                    <Link to={`/session-template/${sid}`}>Detail</Link>
                                </li>
                                {(() => {
                                    // Defensive code: Only run this if we have data.
                                    if (sessionTemplate !== undefined && sessionTemplate !== null && sessionTemplate !== "") {
                                        // Show based on session type.
                                        switch (sessionTemplate.sessionType) {
                                            case "base": return (
                                                <li>
                                                    <Link to={`/session-template/${sid}/video-sections`}>Video Sections</Link>
                                                </li>
                                            );
                                            case "sleep": return (
                                                <li>
                                                    <Link to={`/session-template/${sid}/sleep-questions`}>Sleep Questions</Link>
                                                </li>
                                            );
                                            case "breath": return (
                                                <li>
                                                    <Link class="is-active" to={`/session-template/${sid}/breathwork-options`}><strong>Breathing Options</strong></Link>
                                                </li>
                                            );
                                            default: return null;
                                        };
                                    }
                                    // In case we don't have a session template.
                                    return null;
                                })()}
                            </ul>
                        </div>

                        {isFetching
                            ?
                            <PageLoadingContent displayMessage={"Please wait"} />
                            :
                            <>
                                <div class="columns">

                                    <div class="column">

                                        <div class="columns">
                                            <div class="column">
                                                <p class="subtitle"><FontAwesomeIcon className="fas" icon={faLungs} />&nbsp;Breathwork Options</p>
                                            </div>

                                        </div>

                                        {sessionTemplate && sessionTemplate.breathworkOptions && sessionTemplate.breathworkOptions.length > 0
                                            ? <>
                                                {sessionTemplate.breathworkOptions.map((object, i) => <BreathworkOptionRow sid={sid} obj={object} i={i} key={i} onSelectBreathworkOptionForDeletion={onSelectBreathworkOptionForDeletion} />)}
                                            </>
                                            : <>
                                                <div class="hero-body">
                                                  <p class="title">
                                                      <FontAwesomeIcon className="fas" icon={faTable} />&nbsp;No data
                                                  </p>
                                                  <p class="subtitle">
                                                      No data. <b><Link to={`/session-template/${sid}/breathwork-Options/add`}>Click here&nbsp;<FontAwesomeIcon className="mdi" icon={faArrowRight} /></Link></b> to get started creating your first breathwork option.
                                                  </p>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </>
                        }

                        <div class="columns">
                            <div class="column is-half">
                                <Link to="/session-templates" class="button is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Session Templates</Link>
                            </div>
                            <div class="column is-half has-text-right">
                                <Link to={`/session-template/${sid}/breathwork-options/add`} class="button is-success is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faPlus} />&nbsp;New Breathwork Option</Link>
                            </div>
                        </div>
                    </nav>
                </section>
            </div>
        </>
    );
}

function BreathworkOptionRow(props) {
    const { sid, obj, i, onSelectBreathworkOptionForDeletion } = props;
    if (obj === undefined) {
        return null;
    }
    const { id, name, description } = obj;
    return (
        <div class="box">
            {/*
                ##################################################################
                EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A DESKTOP SCREEN.
                ##################################################################
            */}
            <div class="is-hidden-touch" >
                <div className="columns">
                    <div className="column is-half">
                        <div class="is-pulled-left">
                            <p class="title is-5">{name}</p>
                            <p class="subtitle is-6">{description}</p>
                        </div>
                    </div>
                    <div className="column is-half">
                        <div class="is-pulled-right">
                            <Link to={`/session-template/${sid}/breathwork-option/${i}`} class="button is-primary"><FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View</Link>&nbsp;&nbsp;
                            {/*
                            <Link to={`/session-template/${sid}/breathwork-option/${i}/edit`} class="button is-warning"><FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Update</Link>&nbsp;&nbsp;
                            <button onClick={(e, ses) => onSelectBreathworkOptionForDeletion(e, obj)} class="button is-danger"><FontAwesomeIcon className="mdi" icon={faTrash} />&nbsp;Delete</button>
                            */}
                        </div>
                    </div>
                </div>
            </div>

            {/*
                ###########################################################################
                EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A TABLET OR MOBILE SCREEN.
                ###########################################################################
            */}
            <div class="is-fullwidth is-hidden-desktop mb-5">
                <strong>Name:</strong>&nbsp;{name}
                <br />
                <br />
                <strong>Description:</strong>&nbsp;{description}
                <br />
                <br />
                <Link to={`/session-template/${sid}/breathwork-option/${i}`} class="button is-primary is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View</Link>&nbsp;&nbsp;
                {/*
                <Link to={`/session-template/${sid}/breathwork-option/${i}/edit`} class="button is-warning is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Update</Link>&nbsp;&nbsp;
                <button onClick={(e, ses) => onSelectBreathworkOptionForDeletion(e, obj)} class="button is-danger is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faTrash} />&nbsp;Delete</button>
                */}
            </div>
        </div>

    );
}

export default SessionTemplateDetailForBreathworkOption;
